import { useState, useEffect } from 'react'
import { format } from 'date-fns'

import Head from 'next/head'
import Header from '../../components/Header/Header'
import HeroFullbleed, { BGIMAGE } from '../../components/Hero/HeroFullbleed'
import Blockquote from '../../components/Main/Blockquote'
import Footer from '../../components/Footer/Footer'
import Page from '../../components/Page'

import { getAllArticles, getArticle, getAcfArticle } from '../../data/news'

export default function Home (props) {
  const article = props.page.fullArticle
  if (article.embedded) {
    var image = article._embedded['wp:featuredmedia'][0].src_url
  } else {
    var image = '/public-next/images/quell-placeholder.png'
  }
  return (
    <div id='page' className='site'>
      <Page
        title={article.title.rendered}
        body={article.excerpt.rendered}
        heroBody={props.page.acf.hero.body}
        hideDate={props.page.acf.hero.hideDate}
        bgImage={props.page.acf.hero.bgImage}
        bgId={image.id}
        alt={image.alt}
        height={image.height}
        width={image.width}
        slug={'/' + article.slug}
        disableArrow
        bottomLeft
      >
        <main id='content' className='single-story'>
          <div
            className='container article'
            dangerouslySetInnerHTML={{
              __html: props.page.fullArticle.content.rendered
            }}
          />
        </main>
      </Page>
      <style jsx global>{`
        .container.article {
          font-size: 1.4rem;
          padding: 5rem;
        }

        iframe {
          margin: 2rem;
        }

        @media (min-width: 960px) {
          .article * {
            font-size: 1.8rem;
          }

          .container.article {
            padding: 5rem 20rem 20rem 20rem;
          }
        }

        .article * {
          font-size: 1.8rem;
          font-family: Europa, sans-serif !important;
        }
      `}</style>
    </div>
  )
}

export async function getStaticProps ({ context, params }) {
  let fullArticle = await getArticle(params.slug)
  let fullAcfArticle = await getAcfArticle(params.id) //no category or slug endpoint for ACF REST, so need to grab id

  //Set conditional that if hide_date array is null, return a null value, else return the value of the ACF hide_date[0]: [{hide_date: }] checkbox field
  //Null value means the acf: { body: } object will display as normal. Anything else will hide the body.
  const page = {
    acf: {
      hero: {
        title: fullArticle.title.rendered,
        body:
          '<p>' + format(new Date(fullArticle.date), 'MMMM dd, yyyy') + '</p>',
        bgImage: fullArticle._embedded['wp:featuredmedia']
          ? fullArticle._embedded['wp:featuredmedia'][0].source_url
          : '/public-next/images/quell-placeholder.png',
        hideDate:
          fullArticle.acf.hide_date === null
            ? null
            : fullArticle.acf.hide_date[0] || null
      }
    },
    fullArticle,
    fullAcfArticle
  }

  return {
    props: {
      page
    }
  }
}

export async function getStaticPaths (context) {
  const articles = await getAllArticles()
  const paths = articles.map(article => ({
    params: article
  }))

  return {
    paths,
    fallback: false
  }
}
